module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "growth-dashboard-container"
  }, [_c('section', {
    staticClass: "dashboard"
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "page-icon-wrapper mr-3"
  }, [_c('i', {
    staticClass: "fa fa-balance-scale page-icon"
  })]), _vm._v(" "), _c('div', [_c('h4', {
    staticClass: "page-title mb-1"
  }, [_vm._v("Outstanding Dashboard")]), _vm._v(" "), _c('p', {
    staticClass: "page-subtitle text-muted mb-0"
  }, [_c('i', {
    staticClass: "fa fa-calendar-alt mr-2"
  }), _vm._v("\n              Summary and analysis of outstanding amounts\n            ")])])])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "page-actions"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.refreshDashboard
    }
  }, [_c('i', {
    staticClass: "fa fa-sync-alt",
    class: {
      'fa-spin': _vm.isRefreshing
    }
  }), _vm._v("\n            Refresh\n          ")])], 1)])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-4 cards-row"
  }, [_c('b-col', {
    staticClass: "mb-3 px-2 px-md-3",
    attrs: {
      "lg": "3",
      "md": "4",
      "sm": "6",
      "cols": "12"
    }
  }, [_c('b-card', {
    staticClass: "summary-card h-100 border-0 shadow-sm gradient-info p-0"
  }, [_c('div', {
    staticClass: "card-body p-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center flex-nowrap"
  }, [_c('div', {
    staticClass: "card-icon bg-info text-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 mr-2 mr-md-3"
  }, [_c('i', {
    staticClass: "fa fa-calculator"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1 min-width-0"
  }, [_c('h6', {
    staticClass: "card-title text-muted mb-0 small text-truncate"
  }, [_vm._v("Net Amount")]), _vm._v(" "), _c('h5', {
    staticClass: "mb-0 text-info text-truncate font-weight-bold currency-text"
  }, [_vm._v("\n                  " + _vm._s(_vm.formatCurrency(_vm.summary.totalNetAmount)) + "\n                ")])])])])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3 px-2 px-md-3",
    attrs: {
      "lg": "3",
      "md": "4",
      "sm": "6",
      "cols": "12"
    }
  }, [_c('b-card', {
    staticClass: "summary-card h-100 border-0 shadow-sm gradient-warning p-0"
  }, [_c('div', {
    staticClass: "card-body p-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center flex-nowrap"
  }, [_c('div', {
    staticClass: "card-icon bg-warning text-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 mr-2 mr-md-3"
  }, [_c('i', {
    staticClass: "fa fa-wallet"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1 min-width-0"
  }, [_c('h6', {
    staticClass: "card-title text-muted mb-0 small text-truncate"
  }, [_vm._v("On Account")]), _vm._v(" "), _c('h5', {
    staticClass: "mb-0 text-warning text-truncate font-weight-bold currency-text"
  }, [_vm._v("\n                  " + _vm._s(_vm.formatCurrency(_vm.summary.totalOnAccountAmt)) + "\n                ")])])])])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3 px-2 px-md-3",
    attrs: {
      "lg": "3",
      "md": "4",
      "sm": "6",
      "cols": "12"
    }
  }, [_c('b-card', {
    staticClass: "summary-card h-100 border-0 shadow-sm gradient-primary p-0"
  }, [_c('div', {
    staticClass: "card-body p-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center flex-nowrap"
  }, [_c('div', {
    staticClass: "card-icon bg-primary text-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 mr-2 mr-md-3"
  }, [_c('i', {
    staticClass: "fa fa-rupee-sign"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1 min-width-0"
  }, [_c('h6', {
    staticClass: "card-title text-muted mb-0 small text-truncate"
  }, [_vm._v("Outstanding")]), _vm._v(" "), _c('h5', {
    staticClass: "mb-0 text-primary text-truncate font-weight-bold currency-text"
  }, [_vm._v("\n                  " + _vm._s(_vm.formatCurrency(_vm.summary.totalOutstanding)) + "\n                ")])])])])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3 px-2 px-md-3",
    attrs: {
      "lg": "3",
      "md": "4",
      "sm": "6",
      "cols": "12"
    }
  }, [_c('b-card', {
    staticClass: "summary-card h-100 border-0 shadow-sm gradient-danger p-0"
  }, [_c('div', {
    staticClass: "card-body p-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center flex-nowrap"
  }, [_c('div', {
    staticClass: "card-icon bg-danger text-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 mr-2 mr-md-3"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1 min-width-0"
  }, [_c('h6', {
    staticClass: "card-title text-muted mb-0 small text-truncate"
  }, [_vm._v("Due Amount")]), _vm._v(" "), _c('h5', {
    staticClass: "mb-0 text-danger text-truncate font-weight-bold currency-text"
  }, [_vm._v("\n                  " + _vm._s(_vm.formatCurrency(_vm.summary.totalDueAmount)) + "\n                ")])])])])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3 px-2 px-md-3",
    attrs: {
      "lg": "3",
      "md": "4",
      "sm": "6",
      "cols": "12"
    }
  }, [_c('b-card', {
    staticClass: "summary-card h-100 border-0 shadow-sm gradient-success p-0"
  }, [_c('div', {
    staticClass: "card-body p-3 text-center"
  }, [_c('h6', {
    staticClass: "card-title text-muted mb-1 small"
  }, [_vm._v("Invoices")]), _vm._v(" "), _c('h5', {
    staticClass: "mb-0 text-success font-weight-bold"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.summary.totalInvoices)))])])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3 px-2 px-md-3",
    attrs: {
      "lg": "3",
      "md": "4",
      "sm": "6",
      "cols": "12"
    }
  }, [_c('b-card', {
    staticClass: "summary-card h-100 border-0 shadow-sm gradient-info-light p-0"
  }, [_c('div', {
    staticClass: "card-body p-3 text-center"
  }, [_c('h6', {
    staticClass: "card-title text-muted mb-1 small"
  }, [_vm._v("Clients")]), _vm._v(" "), _c('h5', {
    staticClass: "mb-0 text-info font-weight-bold"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.summary.totalClients)))])])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3 px-2 px-md-3",
    attrs: {
      "lg": "3",
      "md": "4",
      "sm": "6",
      "cols": "12"
    }
  }, [_c('b-card', {
    staticClass: "summary-card h-100 border-0 shadow-sm gradient-warning-light p-0"
  }, [_c('div', {
    staticClass: "card-body p-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center flex-nowrap"
  }, [_c('div', {
    staticClass: "card-icon bg-warning text-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 mr-2 mr-md-3"
  }, [_c('i', {
    staticClass: "fa fa-building"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1 min-width-0"
  }, [_c('h6', {
    staticClass: "card-title text-muted mb-0 small text-truncate"
  }, [_vm._v("Branches")]), _vm._v(" "), _c('h5', {
    staticClass: "mb-0 text-warning text-truncate font-weight-bold"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.summary.totalBranches)))])])])])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3 px-2 px-md-3",
    attrs: {
      "lg": "3",
      "md": "4",
      "sm": "6",
      "cols": "12"
    }
  }, [_c('b-card', {
    staticClass: "summary-card h-100 border-0 shadow-sm gradient-secondary p-0"
  }, [_c('div', {
    staticClass: "card-body p-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center flex-nowrap"
  }, [_c('div', {
    staticClass: "card-icon bg-secondary text-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 mr-2 mr-md-3"
  }, [_c('i', {
    staticClass: "fa fa-user-tie"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1 min-width-0"
  }, [_c('h6', {
    staticClass: "card-title text-muted mb-0 small text-truncate"
  }, [_vm._v("Agents")]), _vm._v(" "), _c('h5', {
    staticClass: "mb-0 text-secondary text-truncate font-weight-bold"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.summary.totalAgents)))])])])])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3 px-2 px-md-3",
    attrs: {
      "lg": "3",
      "md": "4",
      "sm": "6",
      "cols": "12"
    }
  }, [_c('b-card', {
    staticClass: "summary-card h-100 border-0 shadow-sm gradient-dark p-0"
  }, [_c('div', {
    staticClass: "card-body p-3"
  }, [_c('div', {
    staticClass: "d-flex align-items-center flex-nowrap"
  }, [_c('div', {
    staticClass: "card-icon bg-dark text-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 mr-2 mr-md-3"
  }, [_c('i', {
    staticClass: "fa fa-ship"
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow-1 min-width-0"
  }, [_c('h6', {
    staticClass: "card-title text-muted mb-0 small text-truncate"
  }, [_vm._v("Shipping")]), _vm._v(" "), _c('h5', {
    staticClass: "mb-0 text-dark text-truncate font-weight-bold"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.summary.totalShippingLines)))])])])])])], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "lg": "8"
    }
  }, [_c('b-card', {
    staticClass: "summary-card h-100 border-0 shadow-sm"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-3"
  }, [_c('h6', {
    staticClass: "card-title text-muted mb-0"
  }, [_vm._v("Monthly Outstanding Trend")]), _vm._v(" "), (_vm.monthlyChartSeries && _vm.monthlyChartSeries[0] && _vm.monthlyChartSeries[0].data && _vm.monthlyChartSeries[0].data.length) ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n              Last " + _vm._s(_vm.monthlyChartOptions && _vm.monthlyChartOptions.xaxis && _vm.monthlyChartOptions.xaxis.categories ? _vm.monthlyChartOptions.xaxis.categories.length : 0) + " months\n            ")]) : _vm._e()]), _vm._v(" "), (_vm.monthlyChartSeries && _vm.monthlyChartSeries[0] && _vm.monthlyChartSeries[0].data && _vm.monthlyChartSeries[0].data.length) ? _c('div', [_c('apexchart', {
    attrs: {
      "type": "line",
      "height": "260",
      "options": _vm.monthlyChartOptions,
      "series": _vm.monthlyChartSeries
    }
  })], 1) : _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("\n            No monthly data available.\n          ")])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "lg": "4"
    }
  }, [_c('b-card', {
    staticClass: "summary-card h-100 border-0 shadow-sm"
  }, [_c('h6', {
    staticClass: "card-title text-muted mb-3"
  }, [_vm._v("Entity Mix")]), _vm._v(" "), (_vm.totalEntityCount) ? _c('div', [_c('b-progress', {
    staticClass: "summary-entity-progress",
    attrs: {
      "height": "18px"
    }
  }, [_c('b-progress-bar', {
    attrs: {
      "value": _vm.summary.totalClients || 0,
      "max": _vm.totalEntityCount,
      "variant": "info"
    }
  }, [_vm._v("\n                Clients\n              ")]), _vm._v(" "), _c('b-progress-bar', {
    attrs: {
      "value": _vm.summary.totalAgents || 0,
      "max": _vm.totalEntityCount,
      "variant": "success"
    }
  }, [_vm._v("\n                Agents\n              ")]), _vm._v(" "), _c('b-progress-bar', {
    attrs: {
      "value": _vm.summary.totalBranches || 0,
      "max": _vm.totalEntityCount,
      "variant": "warning"
    }
  }, [_vm._v("\n                Branches\n              ")]), _vm._v(" "), _c('b-progress-bar', {
    attrs: {
      "value": _vm.summary.totalShippingLines || 0,
      "max": _vm.totalEntityCount,
      "variant": "primary"
    }
  }, [_vm._v("\n                Shipping\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between mt-2 small text-muted"
  }, [_c('span', [_vm._v("Clients: " + _vm._s(_vm.formatNumber(_vm.summary.totalClients)))]), _vm._v(" "), _c('span', [_vm._v("Agents: " + _vm._s(_vm.formatNumber(_vm.summary.totalAgents)))])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-between small text-muted"
  }, [_c('span', [_vm._v("Branches: " + _vm._s(_vm.formatNumber(_vm.summary.totalBranches)))]), _vm._v(" "), _c('span', [_vm._v("Shipping: " + _vm._s(_vm.formatNumber(_vm.summary.totalShippingLines)))])])], 1) : _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("\n            No summary data available.\n          ")])])], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "border-0 shadow-sm main-content-card",
    staticStyle: {
      "border-radius": "8px",
      "overflow": "hidden"
    },
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "tabs-scroll-container"
  }, [_c('b-tabs', {
    staticClass: "premium-tabs",
    attrs: {
      "card": "",
      "pills": ""
    },
    on: {
      "input": _vm.onTabChange
    },
    model: {
      value: (_vm.activeTabIndex),
      callback: function($$v) {
        _vm.activeTabIndex = $$v
      },
      expression: "activeTabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Base List"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Client Aging"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "All Aging"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Due Client Aging"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Year-wise"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Summary / Monthly"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Client-wise"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Client Monthly"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "On Acc Client Aging"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Client ↔ Branch"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Agent-wise"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Agent Monthly"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Agent ↔ Branch"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Shipping Line-wise"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Shipping Monthly"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Shipping ↔ Branch"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Branch-wise"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Branch Monthly"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Branch ↔ Client"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Branch ↔ Agent"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Branch ↔ Shipping"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Assignments"
    }
  })], 1)], 1), _vm._v(" "), _c('b-card-header', {
    staticClass: "bg-white border-bottom p-3 p-md-4"
  }, [_c('div', {
    staticClass: "d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3"
  }, [_c('h4', {
    staticClass: "mb-3 mb-md-0 text-primary font-weight-bold page-inner-title"
  }, [_c('i', {
    staticClass: "fa fa-check-circle mr-2"
  }), _vm._v("Ledger Outstanding\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-wrap align-items-center action-buttons-group"
  }, [_c('b-input-group', {
    staticClass: "search-input-group mb-2 mb-md-0 mr-md-3"
  }, [_c('b-input-group-prepend', {
    staticClass: "bg-light border-right-0",
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-search text-muted"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "border-left-0 bg-light",
    attrs: {
      "placeholder": "Search..."
    },
    model: {
      value: (_vm.globalSearch),
      callback: function($$v) {
        _vm.globalSearch = $$v
      },
      expression: "globalSearch"
    }
  }), _vm._v(" "), (_vm.globalSearch) ? _c('b-input-group-append', [_c('b-button', {
    staticClass: "text-muted p-0 px-2",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "variant": "link"
    },
    on: {
      "click": _vm.clearGlobalSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex w-100 w-md-auto mt-2 mt-md-0 justify-content-between justify-content-md-start"
  }, [_c('b-button', {
    staticClass: "flex-grow-1 flex-md-grow-0 mr-1",
    attrs: {
      "variant": "outline-primary",
      "size": "sm"
    },
    on: {
      "click": _vm.refreshDashboard
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.isRefreshing
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline ml-1"
  }, [_vm._v("Refresh")])]), _vm._v(" "), _c('b-button', {
    staticClass: "flex-grow-1 flex-md-grow-0 mr-1",
    attrs: {
      "variant": "outline-success",
      "size": "sm"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline ml-1"
  }, [_vm._v("Export")])]), _vm._v(" "), _c('b-button', {
    staticClass: "flex-grow-1 flex-md-grow-0 mr-1",
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.showImportModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline ml-1"
  }, [_vm._v("Import")])]), _vm._v(" "), _c('b-button', {
    staticClass: "flex-grow-1 flex-md-grow-0 mr-1",
    attrs: {
      "variant": "outline-info",
      "size": "sm"
    },
    on: {
      "click": _vm.openDataUpdatesModal
    }
  }, [_c('i', {
    staticClass: "fa fa-history"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline ml-1"
  }, [_vm._v("Data Updates")])]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.ledger-filters-collapse",
      modifiers: {
        "ledger-filters-collapse": true
      }
    }],
    staticClass: "flex-grow-1 flex-md-grow-0",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm"
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" "), _c('span', {
    staticClass: "d-none d-sm-inline ml-1"
  }, [_vm._v("Filters")])])], 1)], 1)]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "ledger-filters-collapse"
    },
    model: {
      value: (_vm.filtersVisible),
      callback: function($$v) {
        _vm.filtersVisible = $$v
      },
      expression: "filtersVisible"
    }
  }, [_c('b-card', {
    staticClass: "bg-light border-0 mb-3"
  }, [_c('b-row', [(_vm.currentTabKey === 'year-wise') ? _c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Year")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "2020",
      "max": new Date().getFullYear() + 1
    },
    on: {
      "change": _vm.loadYearWise
    },
    model: {
      value: (_vm.filterYear),
      callback: function($$v) {
        _vm.filterYear = _vm._n($$v)
      },
      expression: "filterYear"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "d-flex align-items-end mb-2",
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-danger",
      "size": "sm"
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_c('i', {
    staticClass: "fa fa-times mr-1"
  }), _vm._v(" Clear\n                ")])], 1)], 1), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n              Add more filters (branch, client, date range) and pass as params to APIs.\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('b-card-body', {
    staticClass: "p-0"
  }, [(
    _vm.tabChartSeries &&
    _vm.tabChartSeries.length &&
    _vm.tabChartSeries[0].data &&
    _vm.tabChartSeries[0].data.length
  ) ? _c('div', {
    staticClass: "px-4 pt-3"
  }, [_c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "220",
      "options": _vm.tabChartOptions,
      "series": _vm.tabChartSeries
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-table', {
    staticClass: "mb-0 custom-table",
    attrs: {
      "items": _vm.tableItems,
      "fields": _vm.currentFieldsWithSn,
      "show-empty": "",
      "hover": "",
      "head-variant": "light",
      "sticky-header": "600px",
      "responsive": "",
      "no-border-collapse": ""
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row) {
        return [_c('span', [_vm._v(_vm._s(row.index + 1 + (_vm.currentPage - 1) * _vm.currentPerPage))])]
      }
    }, {
      key: "clientName",
      fn: function(row) {
        return [(_vm.currentTabKey === 'client-pending-days' || _vm.currentTabKey === 'client-on-acc-aging' || _vm.currentTabKey === 'client-due-aging') ? _c('b-link', {
          staticClass: "font-weight-bold",
          on: {
            "click": function($event) {
              _vm.openClientInvoices(row.item)
            }
          }
        }, [_vm._v("\n              " + _vm._s(row.item.clientName) + "\n            ")]) : _c('span', [_vm._v(_vm._s(row.item.clientName))])]
      }
    }, {
      key: "_expand",
      fn: function(row) {
        return [(_vm.currentTabKey === 'client-wise-monthly' || _vm.currentTabKey === 'client-branch-wise' || _vm.currentTabKey === 'agent-wise-monthly' || _vm.currentTabKey === 'agent-branch-wise' || _vm.currentTabKey === 'shipping-line-wise-monthly' || _vm.currentTabKey === 'shipping-line-branch-wise' || _vm.currentTabKey === 'branch-wise-monthly' || _vm.currentTabKey === 'branch-client-wise' || _vm.currentTabKey === 'branch-agent-wise' || _vm.currentTabKey === 'branch-shipping-line-wise') ? _c('b-button', {
          staticClass: "p-0 text-secondary",
          attrs: {
            "variant": "link",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.currentTabKey === 'client-wise-monthly' ?
                _vm.toggleClientMonthlyRow(row.item.clientId) :
                _vm.currentTabKey === 'client-branch-wise' ?
                _vm.toggleClientBranchRow(row.item.clientId) :
                _vm.currentTabKey === 'agent-wise-monthly' ?
                _vm.toggleAgentMonthlyRow(row.item.agentId) :
                _vm.currentTabKey === 'agent-branch-wise' ?
                _vm.toggleAgentBranchRow(row.item.agentId) :
                _vm.currentTabKey === 'shipping-line-wise-monthly' ?
                _vm.toggleShippingMonthlyRow(row.item.shippingLineId) :
                _vm.currentTabKey === 'branch-wise-monthly' ?
                _vm.toggleBranchMonthlyRow(row.item.branchId) :
                _vm.currentTabKey === 'branch-client-wise' ?
                _vm.toggleBranchClientRow(row.item.branchId) :
                _vm.currentTabKey === 'branch-agent-wise' ?
                _vm.toggleBranchAgentRow(row.item.branchId) :
                _vm.currentTabKey === 'branch-shipping-line-wise' ?
                _vm.toggleBranchShippingRow(row.item.branchId) :
                _vm.toggleShippingBranchRow(row.item.shippingLineId)
            }
          }
        }, [_c('i', {
          staticClass: "fa",
          class: _vm.expandChevronDown(row) ? 'fa-chevron-down' : 'fa-chevron-right'
        })]) : _vm._e()]
      }
    }, {
      key: "row-details",
      fn: function(row) {
        return [((_vm.currentTabKey === 'client-wise-monthly' || _vm.currentTabKey === 'shipping-line-wise-monthly' || _vm.currentTabKey === 'branch-wise-monthly') && row.item.monthlyData) ? _c('div', {
          staticClass: "bg-light p-3"
        }, [(_vm.detailMonthlyChartConfig(row.item.monthlyData)) ? _c('div', {
          staticClass: "mb-3"
        }, [_c('apexchart', {
          attrs: {
            "type": "line",
            "height": "180",
            "options": _vm.detailMonthlyChartConfig(row.item.monthlyData).options,
            "series": _vm.detailMonthlyChartConfig(row.item.monthlyData).series
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('b-table', {
          staticClass: "mb-0",
          attrs: {
            "items": _vm.monthlyDataAsRows(row.item.monthlyData),
            "fields": _vm.clientMonthlyDetailFields,
            "small": "",
            "striped": "",
            "responsive": ""
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.currentTabKey === 'client-branch-wise' && row.item.branch && row.item.branch.length) ? _c('div', {
          staticClass: "bg-light p-3"
        }, [(_vm.detailChartConfig('clientBranch', row.item.branch)) ? _c('div', {
          staticClass: "mb-3"
        }, [_c('apexchart', {
          attrs: {
            "type": "bar",
            "height": "180",
            "options": _vm.detailChartConfig('clientBranch', row.item.branch).options,
            "series": _vm.detailChartConfig('clientBranch', row.item.branch).series
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('b-table', {
          staticClass: "mb-0",
          attrs: {
            "items": row.item.branch,
            "fields": _vm.clientBranchDetailFields,
            "small": "",
            "striped": "",
            "responsive": ""
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.currentTabKey === 'agent-wise-monthly' && row.item.monthlyData) ? _c('div', {
          staticClass: "bg-light p-3"
        }, [(_vm.detailMonthlyChartConfig(row.item.monthlyData)) ? _c('div', {
          staticClass: "mb-3"
        }, [_c('apexchart', {
          attrs: {
            "type": "line",
            "height": "180",
            "options": _vm.detailMonthlyChartConfig(row.item.monthlyData).options,
            "series": _vm.detailMonthlyChartConfig(row.item.monthlyData).series
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('b-table', {
          staticClass: "mb-0",
          attrs: {
            "items": _vm.monthlyDataAsRows(row.item.monthlyData),
            "fields": _vm.clientMonthlyDetailFields,
            "small": "",
            "striped": "",
            "responsive": ""
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.currentTabKey === 'agent-branch-wise' && row.item.branch && row.item.branch.length) ? _c('div', {
          staticClass: "bg-light p-3"
        }, [(_vm.detailChartConfig('agentBranch', row.item.branch)) ? _c('div', {
          staticClass: "mb-3"
        }, [_c('apexchart', {
          attrs: {
            "type": "bar",
            "height": "180",
            "options": _vm.detailChartConfig('agentBranch', row.item.branch).options,
            "series": _vm.detailChartConfig('agentBranch', row.item.branch).series
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('b-table', {
          staticClass: "mb-0",
          attrs: {
            "items": row.item.branch,
            "fields": _vm.clientBranchDetailFields,
            "small": "",
            "striped": "",
            "responsive": ""
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.currentTabKey === 'shipping-line-branch-wise' && row.item.branch && row.item.branch.length) ? _c('div', {
          staticClass: "bg-light p-3"
        }, [(_vm.detailChartConfig('shippingBranch', row.item.branch)) ? _c('div', {
          staticClass: "mb-3"
        }, [_c('apexchart', {
          attrs: {
            "type": "bar",
            "height": "180",
            "options": _vm.detailChartConfig('shippingBranch', row.item.branch).options,
            "series": _vm.detailChartConfig('shippingBranch', row.item.branch).series
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('b-table', {
          staticClass: "mb-0",
          attrs: {
            "items": row.item.branch,
            "fields": _vm.clientBranchDetailFields,
            "small": "",
            "striped": "",
            "responsive": ""
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.currentTabKey === 'branch-client-wise' && row.item.client && row.item.client.length) ? _c('div', {
          staticClass: "bg-light p-3"
        }, [(_vm.detailChartConfig('branchClient', row.item.client)) ? _c('div', {
          staticClass: "mb-3"
        }, [_c('apexchart', {
          attrs: {
            "type": "bar",
            "height": "180",
            "options": _vm.detailChartConfig('branchClient', row.item.client).options,
            "series": _vm.detailChartConfig('branchClient', row.item.client).series
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('b-table', {
          staticClass: "mb-0",
          attrs: {
            "items": row.item.client,
            "fields": _vm.branchClientDetailFields,
            "small": "",
            "striped": "",
            "responsive": ""
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.currentTabKey === 'branch-agent-wise' && row.item.agent && row.item.agent.length) ? _c('div', {
          staticClass: "bg-light p-3"
        }, [(_vm.detailChartConfig('branchAgent', row.item.agent)) ? _c('div', {
          staticClass: "mb-3"
        }, [_c('apexchart', {
          attrs: {
            "type": "bar",
            "height": "180",
            "options": _vm.detailChartConfig('branchAgent', row.item.agent).options,
            "series": _vm.detailChartConfig('branchAgent', row.item.agent).series
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('b-table', {
          staticClass: "mb-0",
          attrs: {
            "items": row.item.agent,
            "fields": _vm.branchAgentDetailFields,
            "small": "",
            "striped": "",
            "responsive": ""
          }
        })], 1) : _vm._e(), _vm._v(" "), (_vm.currentTabKey === 'branch-shipping-line-wise' && row.item.shippingLine && row.item.shippingLine.length) ? _c('div', {
          staticClass: "bg-light p-3"
        }, [(_vm.detailChartConfig('branchShipping', row.item.shippingLine)) ? _c('div', {
          staticClass: "mb-3"
        }, [_c('apexchart', {
          attrs: {
            "type": "bar",
            "height": "180",
            "options": _vm.detailChartConfig('branchShipping', row.item.shippingLine).options,
            "series": _vm.detailChartConfig('branchShipping', row.item.shippingLine).series
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('b-table', {
          staticClass: "mb-0",
          attrs: {
            "items": row.item.shippingLine,
            "fields": _vm.branchShippingDetailFields,
            "small": "",
            "striped": "",
            "responsive": ""
          }
        })], 1) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "empty"
  }, [_c('div', {
    staticClass: "text-center text-muted my-5"
  }, [_c('i', {
    staticClass: "fa fa-inbox fa-3x mb-3"
  }), _vm._v(" "), _c('p', [_vm._v("No records found.")])])])], 2)], 1), _vm._v(" "), _c('b-card-footer', {
    staticClass: "bg-white border-top py-3"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("\n            Showing\n            " + _vm._s(_vm.currentTotalRows > 0 ?
    (_vm.currentPage - 1) * _vm.currentPerPage + 1 :
    0) + "\n            to\n            " + _vm._s(Math.min(_vm.currentPage * _vm.currentPerPage, _vm.currentTotalRows)) + "\n            of " + _vm._s(_vm.currentTotalRows) + " entries\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-select', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "70px"
    },
    attrs: {
      "options": [10, 25, 50, 100],
      "size": "sm"
    },
    model: {
      value: (_vm.currentPerPage),
      callback: function($$v) {
        _vm.currentPerPage = $$v
      },
      expression: "currentPerPage"
    }
  }), _vm._v(" "), _c('b-pagination', {
    staticClass: "mb-0 custom-pagination",
    attrs: {
      "total-rows": _vm.currentTotalRows,
      "per-page": _vm.currentPerPage,
      "align": "right",
      "pills": ""
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Import Ledger Outstanding",
      "size": "xl",
      "hide-footer": ""
    },
    model: {
      value: (_vm.showImportModal),
      callback: function($$v) {
        _vm.showImportModal = $$v
      },
      expression: "showImportModal"
    }
  }, [_c('LedgerOutstandingBulkUpload', {
    on: {
      "upload-success": _vm.onUploadSuccess
    }
  })], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Ledger Data Updates",
      "size": "lg",
      "hide-footer": ""
    },
    model: {
      value: (_vm.showDataUpdatesModal),
      callback: function($$v) {
        _vm.showDataUpdatesModal = $$v
      },
      expression: "showDataUpdatesModal"
    }
  }, [
    [_c('div', {
      staticClass: "d-flex justify-content-between align-items-center w-100"
    }, [_c('div', {
      staticClass: "font-weight-bold"
    }, [_vm._v("Ledger Data Updates")]), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('b-button', {
      staticClass: "mr-3",
      attrs: {
        "variant": "outline-success",
        "size": "sm",
        "disabled": _vm.dataUpdatesLoading || !_vm.dataUpdatesRows.length
      },
      on: {
        "click": _vm.exportDataUpdatesExcel
      }
    }, [_c('i', {
      staticClass: "fa fa-file-excel-o mr-1"
    }), _vm._v(" Export Excel\n          ")]), _vm._v(" "), _c('button', {
      staticClass: "close",
      attrs: {
        "type": "button",
        "aria-label": "Close"
      },
      on: {
        "click": function($event) {
          _vm.showDataUpdatesModal = false
        }
      }
    }, [_vm._v("×")])], 1)])], _vm._v(" "), (_vm.dataUpdatesLoading) ? _c('div', {
      staticClass: "text-center py-4"
    }, [_c('b-spinner', {
      attrs: {
        "variant": "info"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "mt-2 text-muted mb-0"
    }, [_vm._v("Loading data updates...")])], 1) : _c('div', [_c('b-table', {
      staticClass: "mb-0 custom-table",
      attrs: {
        "items": _vm.dataUpdatesRows,
        "fields": _vm.dataUpdatesFields,
        "show-empty": "",
        "hover": "",
        "head-variant": "light",
        "responsive": ""
      },
      scopedSlots: _vm._u([{
        key: "cell(created_count)",
        fn: function(row) {
          return [_vm._v("\n          " + _vm._s(_vm.formatNumber(row.item.created_count)) + "\n        ")]
        }
      }, {
        key: "cell(updated_count)",
        fn: function(row) {
          return [_vm._v("\n          " + _vm._s(_vm.formatNumber(row.item.updated_count)) + "\n        ")]
        }
      }])
    }, [_c('template', {
      slot: "empty"
    }, [_c('div', {
      staticClass: "text-center text-muted my-4"
    }, [_c('p', {
      staticClass: "mb-0"
    }, [_vm._v("No update records found.")])])])], 2)], 1)
  ], 2), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "xl",
      "hide-footer": "",
      "title": 'Invoices - ' + (_vm.selectedClient ? _vm.selectedClient.clientName : '')
    },
    model: {
      value: (_vm.showClientInvoicesModal),
      callback: function($$v) {
        _vm.showClientInvoicesModal = $$v
      },
      expression: "showClientInvoicesModal"
    }
  }, [
    [_c('div', {
      staticClass: "d-flex justify-content-between align-items-center w-100"
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('b-button', {
      staticClass: "mr-3",
      attrs: {
        "variant": "outline-success",
        "size": "sm",
        "disabled": _vm.clientInvoicesLoading
      },
      on: {
        "click": _vm.exportClientInvoices
      }
    }, [_c('i', {
      staticClass: "fa fa-file-excel-o mr-1"
    }), _vm._v(" Export Excel\n          ")]), _vm._v(" "), _c('button', {
      staticClass: "close",
      attrs: {
        "type": "button",
        "aria-label": "Close"
      },
      on: {
        "click": function($event) {
          _vm.showClientInvoicesModal = false
        }
      }
    }, [_vm._v("×")])], 1)])], _vm._v(" "), (_vm.clientInvoicesLoading && !_vm.clientInvoices.length) ? _c('div', {
      staticClass: "text-center py-5"
    }, [_c('b-spinner', {
      attrs: {
        "variant": "primary"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "mt-2 text-muted"
    }, [_vm._v("Loading invoices...")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.clientInvoices.length || !_vm.clientInvoicesLoading),
        expression: "clientInvoices.length || !clientInvoicesLoading"
      }]
    }, [(_vm.clientInvoicesLoading && _vm.clientInvoices.length > 0) ? _c('div', {
      staticClass: "text-center mb-2"
    }, [_c('b-spinner', {
      attrs: {
        "small": "",
        "variant": "primary"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ml-2 small text-muted"
    }, [_vm._v("Refreshing list...")])], 1) : _vm._e(), _vm._v(" "), _c('b-table', {
      staticClass: "mb-3 custom-table",
      attrs: {
        "items": _vm.clientInvoices,
        "fields": _vm.listFields,
        "show-empty": "",
        "hover": "",
        "head-variant": "light",
        "sticky-header": "450px",
        "responsive": "",
        "no-border-collapse": ""
      }
    }, [_c('template', {
      slot: "empty"
    }, [_c('div', {
      staticClass: "text-center text-muted my-4"
    }, [_c('p', [_vm._v("No invoices found for this client.")])])])], 2), _vm._v(" "), _c('div', {
      staticClass: "d-flex justify-content-between align-items-center mt-3"
    }, [_c('div', {
      staticClass: "text-muted small"
    }, [_vm._v("\n          Total Records: " + _vm._s(_vm.clientInvoicesPagination.totalCount) + "\n        ")]), _vm._v(" "), _c('b-pagination', {
      staticClass: "mb-0",
      attrs: {
        "total-rows": _vm.clientInvoicesPagination.totalCount,
        "per-page": _vm.clientInvoicesPerPage,
        "align": "right",
        "pills": ""
      },
      on: {
        "input": _vm.fetchClientInvoices
      },
      model: {
        value: (_vm.clientInvoicesPage),
        callback: function($$v) {
          _vm.clientInvoicesPage = $$v
        },
        expression: "clientInvoicesPage"
      }
    })], 1)], 1)
  ], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69c03cd0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/ledgerOutstandingDashboard.vue
// module id = 2707
// module chunks = 0